import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { getPerformance } from 'firebase/performance';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyDm6ul_U9KwH4Zr3FOlXHZBhtRQEO_Gz8A',
  authDomain: 'stakeholdertakeover.firebaseapp.com',
  projectId: 'stakeholdertakeover',
  storageBucket: 'stakeholdertakeover.firebasestorage.app',
  messagingSenderId: '533513380174',
  appId: '1:533513380174:web:366bd3d55203201088be1f',
  measurementId: 'G-3ERXQ4L5J6',
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const perf = getPerformance(app);
export const db = getFirestore(app);

// Web substitute for Crashlytics — logs JS errors as Analytics events
window.addEventListener('error', (e) => {
  logEvent(analytics, 'js_error', {
    message: e.message?.slice(0, 100) ?? 'unknown',
    source: e.filename?.slice(0, 100) ?? 'unknown',
    line: e.lineno ?? 0,
  });
});

window.addEventListener('unhandledrejection', (e) => {
  logEvent(analytics, 'js_error', {
    message: String(e.reason)?.slice(0, 100) ?? 'unhandled_rejection',
    source: 'promise',
    line: 0,
  });
});
